import type { GoldSetLabel, GoldSetLabelInput } from '~/entities/gold-set'

export type ReviewFormValues = {
  category: string | null
  sure: boolean | null
  multipleLetters: boolean | null
  notes: string
}

export function toReviewFormValues(label: GoldSetLabel | null): ReviewFormValues {
  return {
    category: label?.category ?? null,
    sure: label?.sure ?? null,
    multipleLetters: label?.multiple_letters ?? null,
    notes: label?.notes ?? '',
  }
}

export function toLabelInput(values: ReviewFormValues, pass: number): GoldSetLabelInput | null {
  if (values.category === null || values.sure === null || values.multipleLetters === null) {
    return null
  }
  return {
    pass,
    category: values.category,
    sure: values.sure,
    multiple_letters: values.multipleLetters,
    notes: values.notes.trim(),
  }
}
